import type { Answers } from '../types/application';

// Pre-filled from what John shared with his Loan Officer.
export const initialAnswers: Answers = {
  goal: 'purchase',
  propertyStage: 'contract',
  propertyType: 'single',
  occupancy: 'primary',
  price: 625000,
  downPayment: 125000,
  propertyStreet: '1428 Linden Ave',
  propertyCity: 'Austin',
  propertyState: 'TX',
  propertyZip: '78704',
  closingDate: '2026-10-28',
  firstName: 'John',
  middleName: 'Andrew',
  lastName: 'Carter',
  suffix: '',
  email: 'john.carter@gmail.com',
  phone: '(512) 555-0198',
  dob: '',
  ssn: '',
  maritalStatus: 'married',
  citizenship: 'citizen',
  currentStreet: '902 E 6th St, Apt 4B',
  currentCity: 'Austin',
  currentState: 'TX',
  currentZip: '78702',
  yearsAtAddress: '3',
  prevStreet: '',
  prevCity: '',
  prevState: '',
  prevZip: '',
  housing: 'rent',
  rent: '2350',
  employmentType: 'w2',
  employers: [
    {
      id: 'e1',
      name: 'Northwind Labs',
      position: 'Senior Product Designer',
      startDate: '2023-03-01',
      endDate: '',
      current: true,
      basePay: '148000',
      payFrequency: 'annual',
      bonus: '',
      commission: '',
      overtime: '',
    },
  ],
  otherIncome: [],
  assets: [
    { id: 'a1', type: 'checking', institution: 'Chase', balance: '84200' },
  ],
  ownsOtherProperty: '',
  properties: [],
  obligations: [],
  declarations: {},
  demographics: { ethnicity: [], race: [], sex: '' },
};

export const initialCompletedSteps = [
  'goal',
  'stage',
  'type',
  'use',
  'price',
  'address',
  'name',
  'contact',
  'status',
  'home',
  'housing',
  'employment',
];

export const initialResumeStep = 'employer';
